import { oneLine } from 'common-tags';
import { FOOD_ITEM_INPUT_SELECTOR } from 'common/FoodUtils';
import {
  AllergenDairy,
  AllergenEggs,
  AllergenGluten,
  AllergenNuts,
  AllergenShellfish,
  AllergenSoy,
  DietaryHalal,
  DietaryKeto,
  DietaryKosher,
  DietaryLowFODMAP,
  DietaryLowSodium,
  DietaryOrganic,
  DietaryPaleo,
  DietarySugarFree,
  DietaryVegan,
  DietaryVegetarian,
  DietaryWhole30,
} from 'src/shared/design-system/Icon';

// ALLERGEN FIELDS
export const DAIRY = {
  title: 'Contains dairy',
  icon: AllergenDairy,
  dataTest: FOOD_ITEM_INPUT_SELECTOR.ALLERGEN.DAIRY,
};

export const EGGS = {
  title: 'Contains eggs',
  icon: AllergenEggs,
  dataTest: FOOD_ITEM_INPUT_SELECTOR.ALLERGEN.EGGS,
};

export const GLUTEN = {
  title: 'Contains gluten',
  description: 'Has gluten, wheat or grain proteins',
  icon: AllergenGluten,
  dataTest: FOOD_ITEM_INPUT_SELECTOR.ALLERGEN.GLUTEN,
};

export const NUTS = {
  title: 'Contains nuts',
  icon: AllergenNuts,
  dataTest: FOOD_ITEM_INPUT_SELECTOR.ALLERGEN.NUTS,
};

export const SOY = {
  title: 'Contains soy/soybeans',
  icon: AllergenSoy,
  dataTest: FOOD_ITEM_INPUT_SELECTOR.ALLERGEN.SOY,
};

export const SHELLFISH = {
  title: 'Contains shellfish',
  icon: AllergenShellfish,
  dataTest: FOOD_ITEM_INPUT_SELECTOR.ALLERGEN.SHELLFISH,
};

// DIETARY FIELDS
export const HALAL = {
  title: 'Halal',
  description: 'Meat prepared in accordance with Islamic law.',
  icon: DietaryHalal,
  dataTest: FOOD_ITEM_INPUT_SELECTOR.DIETARY.HALAL,
};

export const KETO = {
  title: 'Keto',
  description: 'No grains, starchy vegetables, honey, sugar, or baked goods (including gluten-free).',
  icon: DietaryKeto,
  dataTest: FOOD_ITEM_INPUT_SELECTOR.DIETARY.KETO,
};

export const KOSHER = {
  title: 'Kosher',
  description: 'Every major, minor and accompanying ingredient prepared in accordance with Jewish dietary law.',
  icon: DietaryKosher,
  dataTest: FOOD_ITEM_INPUT_SELECTOR.DIETARY.KOSHER,
};

export const LOW_FODMAP = {
  title: 'Low FODMAP',
  description: 'Avoids foods with certain types of carbohydrates, such as cauliflower and asparagus.',
  icon: DietaryLowFODMAP,
  dataTest: FOOD_ITEM_INPUT_SELECTOR.DIETARY.LOW_FODMAP,
  learnMoreLink: 'https://www.ibsdiets.org/wp-content/uploads/2016/03/IBSDiets-FODMAP-chart.pdf',
};

export const LOW_SODIUM = {
  title: 'Low Sodium',
  description: 'Foods that have less than 140mg of sodium (or salt) per serving.',
  icon: DietaryLowSodium,
  dataTest: FOOD_ITEM_INPUT_SELECTOR.DIETARY.LOW_SODIUM,
};

export const ORGANIC = {
  title: 'Organic',
  description: 'Every major, minor, and accompanying ingredient is certified organic.',
  icon: DietaryOrganic,
  dataTest: FOOD_ITEM_INPUT_SELECTOR.DIETARY.ORGANIC,
};

export const PALEO = {
  title: 'Paleo',
  description: oneLine`Dish only includes lean meats, fish, fruits, vegetables, nuts and seeds.
    Excludes grains, legumes, dairy, sugar, and fruit juices.`,
  icon: DietaryPaleo,
  dataTest: FOOD_ITEM_INPUT_SELECTOR.DIETARY.PALEO,
  learnMoreLink: 'https://ultimatepaleoguide.com/files/2012/05/Paleo-Diet-Food-List-PDF.pdf',
};

export const SUGAR_FREE = {
  title: 'Sugar Free',
  dataTest: FOOD_ITEM_INPUT_SELECTOR.DIETARY.SUGAR_FREE,
  icon: DietarySugarFree,
};

export const VEGAN = {
  title: 'Vegan',
  description: 'No animal products like eggs, butter, ghee, honey, or milk.',
  icon: DietaryVegan,
  dataTest: FOOD_ITEM_INPUT_SELECTOR.DIETARY.VEGAN,
};

export const VEGETARIAN = {
  title: 'Vegetarian',
  icon: DietaryVegetarian,
  dataTest: FOOD_ITEM_INPUT_SELECTOR.DIETARY.VEGETARIAN,
};

export const WHOLE30 = {
  title: 'Whole 30',
  description: 'Similar to paleo, but excludes processed meats and allows for ghee/clarified butter.',
  icon: DietaryWhole30,
  dataTest: FOOD_ITEM_INPUT_SELECTOR.DIETARY.WHOLE_30,
  learnMoreLink: 'https://whole30.com/downloads/whole30-shopping-list.pdf',
};
